export const DEVELOPMENT_GTM_ID = 'GTM-ID';
export const PRODUCTION_GTM_ID = 'GTM-WDW3F5';
